import React from 'react';
import { ThinScrollArea } from './ThinScrollArea.styles';

interface ScrollContainerProps {
  maxHeight?: string;
  children: React.ReactNode;
}

export const ScrollContainer: React.FC<ScrollContainerProps> = ({
  maxHeight = 'calc(100vh - 244px)',
  children,
}) => {
  return <ThinScrollArea maxHeight={maxHeight}>{children}</ThinScrollArea>;
};
